module.exports = __webpack_public_path__ + "img/electronic_reserved.5fa107c0.svg";